<template>
    <section v-if="msp.relatedLinks.show && getRelatedLinks.data.length && glb.rentals">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold"><a :href="getRelatedLinks.baseUrl">{{getRelatedLinks.demographicName}}</a> {{molang('search.common.relatedLinks')}}</h2>
            <ul>
                <li v-for="(item, index) in getRelatedLinks.data" :key="index">
                    <a class="link" :href="item.link" :target="item.target || '_self'"><span>{{item.text}}</span></a>
                </li>
            </ul>
        </div>
    </section>
</template>

<script src="./search-relatedlinks.js"></script>
